<template>
<div class="chapter">
<div class="inner_page">
<div class="center">
<p class="structure" xml:lang="en-GB"><span class="bold-italic2"> </span></p>
<p class="author"><span class="bold-italic3"> </span></p>
<p class="author2"><span class="bold-italic3"> </span></p>
<p class="quote-b"><span class="bold-italic">“We are as happy as we make up our minds to be.”</span></p>
<p class="author2"><span class="char-style-override">—Abraham Lincoln</span></p>
<p class="quote-b"><span class="bold-italic">“You may not control all the events that happen to you, but you can decide not to be reduced by them.”</span></p>
<p class="author2"><span class="char-style-override">—Maya Angelou </span></p>
<div class="calibre1" id="calibre_pb_2"></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// HappyHealthyYou_split_002.vue?4aa682c7